export default __webpack_public_path__ + "static/media/wilder_bild_1.f10476f7.jpg";